// src/pages/VerifyEmailPage.tsx
import React, { useEffect, useState } from 'react';
import { Card, Typography, Spin, Result, Button } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../utils/api';

const { Title, Text } = Typography;

export const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState<string>('');
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setStatus('error');
        setMessage('Токен подтверждения не найден в ссылке');
        return;
      }

      try {
        const response: any = await authAPI.verifyEmail(token);
        setStatus('success');
        setMessage(response.data?.message || response.data || 'Email успешно подтвержден!');
      } catch (error: any) {
        console.error('Email verification error:', error);
        const errorMessage = error.response?.data?.detail || error.response?.data?.message || 'Ошибка при подтверждении email';
        setStatus('error');
        setMessage(errorMessage);
      }
    };

    verifyEmail();
  }, [searchParams]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      backgroundColor: '#F0F9F4',
      padding: '20px'
    }}>
      <Card 
        style={{ 
          width: '100%', 
          maxWidth: 600,
          borderRadius: '12px',
          boxShadow: '0 6px 16px rgba(0,0,0,0.08)',
          textAlign: 'center'
        }}
      >
        {status === 'loading' && (
          <div style={{ padding: '40px' }}>
            <Spin size="large" />
            <Title level={3} style={{ marginTop: '20px' }}>Подтверждение email...</Title>
            <Text type="secondary">Пожалуйста, подождите</Text>
          </div>
        )}

        {status === 'success' && (
          <Result
            icon={<CheckCircleOutlined style={{ color: '#7CB342' }} />}
            title="Email успешно подтвержден!"
            subTitle={message}
            extra={[
              <Button 
                type="primary" 
                key="login"
                onClick={() => navigate('/login')}
                size="large"
              >
                Войти в систему
              </Button>
            ]}
          />
        )}

        {status === 'error' && (
          <Result
            icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
            title="Ошибка подтверждения"
            subTitle={message}
            extra={[
              <Button 
                type="primary" 
                key="register"
                onClick={() => navigate('/register')}
                size="large"
              >
                Зарегистрироваться заново
              </Button>,
              <Button 
                key="login"
                onClick={() => navigate('/login')}
                size="large"
              >
                Войти
              </Button>
            ]}
          />
        )}
      </Card>
    </div>
  );
};
